import { memo } from 'react'
import { TooltipV2Props } from '../../types'
import { transformMultiline } from '../../utils'
import { TippyTooltip } from './styles'

/**
 * Tooltip based on Tippy.js
 */
export const TooltipV2 = memo((props: TooltipV2Props) => {
  const {
    value = '',
    multiline = false,
    width,
    textAlign = 'left',
    children,
    position = 'top',
    isActive = true,
    ...rest
  } = props

  const body = transformMultiline(value)

  return isActive ? (
    <TippyTooltip
      maxWidth={width}
      content={body}
      placement={position}
      $isMultiline={multiline}
      $textAlign={textAlign}
      $width={width}
      // this number is selected to tooltips able to appear
      // on top of the modals with ModalOverlay (with z-index: 12000)
      zIndex={rest.zIndex || 13000}
      {...rest}
    >
      {children}
    </TippyTooltip>
  ) : (
    children || null
  )
})
